 <div class="row" [formGroup]="fiterForm">
    <div class="col-lg-4">
        <mat-form-field class="full-width">
            <mat-label>Zeitraum auswählen</mat-label>
            <mat-select formControlName="dropDownTime" (selectionChange)="timeChangedByDropDown($event)"
                [disabled]="!finishedLoadingLineChartUserCount || pdfIsGenerating">
                <mat-option *ngFor="let sortOption of sortOptions" [value]="sortOption.value"
                    [disabled]="sortOption.state">
                    {{sortOption.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-lg-1">
    </div>
</div>

<div class="row">
    <div class="col-lg-6 marginBottom2Rem">
        <button mat-raised-button color="accent"
            [disabled]="!pdfIsDownloadable || !finishedLoadingLineChartUserCount " (click)="generatePDF()"> PDF
            generieren
            <mat-icon *ngIf="pdfIsGenerating">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon>
        </button>
    </div>
</div>
<div class="row">
    <div class="col-lg-12">
        <mat-card appearance="outlined" class="form-card">
            <mat-card-header>
                <mat-card-title-group>
                    <mat-card-title>
                        Nutzerzahlen seit dem {{startDate | date: 'dd.MM.yyyy'}}
                    </mat-card-title>
                </mat-card-title-group>
                <div fxFlex></div>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="!finishedLoadingLineChartUserCount" class="loadingOverlay">
                    <mat-spinner></mat-spinner>
                </div>
                <ibm-line-chart #userCount id="canvas" [data]="data_usercount"
                    [options]="options_line"></ibm-line-chart>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div class="row">
    <div class="col-lg-12">
        <mat-card appearance="outlined" class="form-card">
            <mat-card-header>
                <mat-card-title>
                    Ersparnise seit dem {{startDate | date: 'dd.MM.yyyy'}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="!finishedLoadingLineChartUserCount" class="loadingOverlay">
                    <mat-spinner></mat-spinner>
                </div>
                <ibm-line-chart [data]="data_saving" [options]="options_line"></ibm-line-chart>
            </mat-card-content>
        </mat-card>
    </div>
</div> 